import { Opportunity } from './opportunity';

export class GridActionModel {
    row: Partial<Opportunity>;
    callbacks: Partial<CallbackAction>;
}

export class CallbackAction {
    viewPolicy: () => {};
    viewQuote: () => {};
    emit: () => {};
    emitCar: () => {};
    emitCarLite: () => {};
    editContact: () => {};
    linkPolicy: () => {};
    viewDetails: () => {};
    sendMessage: () => {};
    markAsContacted: () => {};
}
